import { render, staticRenderFns } from "./HandbagIcon.vue?vue&type=template&id=3aaeaa49&"
import script from "./HandbagIcon.vue?vue&type=script&lang=ts&"
export * from "./HandbagIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports